
import { useState } from 'react'
import CustomStore from 'devextreme/data/custom_store';
import SelectBox from 'devextreme-react/select-box';
const edit_cell_render = (params:any) => {
    const [lookups] = useState(new CustomStore({load:params.load, useDefaultSearch: true,}));
    
    const onSelectionChanged= (e:any) =>{params.onChanged(e);}
    return  <SelectBox        
        dataSource={lookups}
        valueExpr="code"
        displayExpr="name"        
        onSelectionChanged={onSelectionChanged}
        showClearButton={true}>        
    </SelectBox>     
  };
  export default edit_cell_render;